'use client'
import { useState, useEffect } from 'react'
import { Switch } from '@headlessui/react'
import { useRouter } from 'next/navigation'
import { updateSearchParams, removeSearchParam, getSearchParams } from "@utils";



function NewDevelopmentFilter({ title, dictionary, lang }) {
    const router = useRouter();

    const [newDevelopment, setNewDevelopment] = useState(false)

    const handleUpdateParams = (e) => {
        console.log(e)
        let newPathName
        if (e == true) {
            newPathName = updateSearchParams(title, e);
        } else {
            newPathName = removeSearchParam(title);
        }

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const newDevelopmentValue = getSearchParams('newdevelopment')

        if (newDevelopmentValue == 'true') {
            setNewDevelopment(true)
        } else {
            setNewDevelopment(false)
        }
    }, [handleUpdateParams])

    return (
        <div className='sm:w-1/2 w-full flex flex-row items-center justify-between mt-2 px-1'>
            <span className='text-sm text-secondary'>{dictionary.filter.onlyIncludeNewDevelopment}</span>
            <Switch
                checked={newDevelopment}
                // onChange={setPetFriendly}
                onChange={(value) => {
                    setNewDevelopment(value)
                    handleUpdateParams(value)
                }}
                className={`${newDevelopment ? 'bg-maincolor' : 'bg-forth'
                    } inline-flex h-6 w-11 items-center rounded-full border-forth border-[1px] shadow-md`}
            >
                <span className="sr-only">{dictionary.filter.onlyIncludeNewDevelopment}</span>
                <span
                    className={`${newDevelopment ? 'translate-x-6' : 'translate-x-1'
                        } inline-block h-4 w-4 transform rounded-full bg-white transition shadow-md`}
                />
            </Switch>
        </div>
    )
}

export default NewDevelopmentFilter